import { QendoIcon } from "~/components/QendoIcon";

import { Space } from "~/constants/sizing";

type DOT = {
    key?: string;
    color: string;
    selectedDotColor?: string;
};

type MarkersProps = {
    dots?: DOT[];
    size?: number;
};

export const MARKER_SIZE = Space.sm;

export const Markers = ({ dots, size = MARKER_SIZE }: MarkersProps) => {
    return (
        <>
            {dots?.map((d) => (
                <QendoIcon
                    name={d.key?.endsWith("flare") ? "zap-filled" : "circle-lg-filled"}
                    color={d.color}
                    key={d.key}
                    size={size}
                />
            ))}
        </>
    );
};
